import { LogoData, LogoType } from '../../company.types';
import combinedLogo from './combined.svg';
import smallLogo from './logo-small.svg';
import standardLogo from './logo.svg';

export const logoData: LogoData = {
    [LogoType.STANDARD]: standardLogo,
    [LogoType.SMALL]: smallLogo,
    [LogoType.COMBINED]: combinedLogo,
    [LogoType.SUB]: '',
};
